<template>
  <div id="app-container" class="app-container-box">
    <div class="check-in--box">
      <div class="check-in-types">
        <van-button
          v-for="(item, index) in clock_in_items"
          :key="index"
          class="check-button"
          :class="{ button_select: type_select == index }"
          @click="itemClick(index)"
        >
          {{ item.name }}
        </van-button>
      </div>

      <div class="check-in-form">
        <van-form>
          <van-cell-group>
            <van-field v-if="select_item_.type == 1">
              <template #input>
                <div class="form-item">
                  <span class="item-label">运动项目</span>
                  <van-field
                    class="input-field"
                    placeholder="请填写运动项目"
                    v-model="form.item_name"
                  />
                </div>
              </template>
            </van-field>
            <van-field name="用户名">
              <template #input>
                <div class="form-item">
                  <span class="item-label">运动时间</span>
                  <van-field
                    class="input-field"
                    readonly
                    placeholder="请选择运动时间"
                    v-model="form.form_time_fmt"
                    @click="show_time_picker = true"
                  />
                </div>
              </template>
            </van-field>
            <van-field name="用户名">
              <template #input>
                <div class="form-item">
                  <span class="item-label">运动地点</span>
                  <van-radio-group
                    v-model="form.place_type"
                    direction="horizontal"
                  >
                    <van-radio :name="1">
                      校内
                      <template #icon="props">
                        <img
                          class="radio-img-icon"
                          :src="props.checked ? radio_select : radio_normal"
                        />
                      </template>
                    </van-radio>
                    <van-radio :name="2">
                      校外
                      <template #icon="props">
                        <img
                          class="radio-img-icon"
                          :src="props.checked ? radio_select : radio_normal"
                        />
                      </template>
                    </van-radio>
                  </van-radio-group>

                  <van-field
                    class="input-field input-field-margin"
                    placeholder="请填写运动地点"
                    v-model="form.place"
                  ></van-field>
                </div>
              </template>
            </van-field>
            <van-field name="用户名">
              <template #input>
                <div class="form-item upload-form-item">
                  <span class="item-label"
                    >上传本人出镜照片<span class="item-label-tip"
                      >（最多三张,支持格式jpg、jpeg、png）</span
                    ></span
                  >
                  <van-uploader
                    v-model="fileList"
                    multiple
                    accept="image/jpg,image/jpeg,image/png"
                    :max-count="3"
                    :preview-size="['29.3vw', '22vw']"
                    :max-size="5 * 1024 * 1024"
                    @oversize="onOversize"
                  >
                    <van-button icon="plus" class="upload-button"></van-button>
                  </van-uploader>
                </div>
              </template>
            </van-field>
            <van-field name="用户名">
              <template #input>
                <div class="form-item">
                  <span class="item-label">公开分享到广场</span>
                  <van-radio-group v-model="form.isopen" direction="horizontal">
                    <van-radio :name="1">
                      是
                      <template #icon="props">
                        <img
                          class="radio-img-icon"
                          :src="props.checked ? radio_select : radio_normal"
                        />
                      </template>
                    </van-radio>
                    <van-radio :name="0">
                      否
                      <template #icon="props">
                        <img
                          class="radio-img-icon"
                          :src="props.checked ? radio_select : radio_normal"
                        />
                      </template>
                    </van-radio>
                  </van-radio-group>
                </div>
              </template>
            </van-field>
          </van-cell-group>
        </van-form>
        <van-button class="button_select submit-button" @click="startSubmit"
          >提 交</van-button
        >

        <div class="tip-box">
          <div class="tip-head">
            <!-- <img src="../../assets/icon_warning.png" /> -->
            <p v-html="noticeInfo.content"></p>
          </div>
        </div>
      </div>

      <van-popup v-model:show="show_time_picker" round position="bottom">
        <van-picker-group
          title="请选择运动时间"
          :tabs="['选择日期', '选择开始时间', '选择结束时间']"
          next-step-text="下一步"
          @confirm="onConfirmTimeFilter"
          @cancel="show_time_picker = false"
        >
          <van-date-picker
            v-model="filter_time.selectDate"
            :max-date="maxDate"
          />
          <van-time-picker v-model="filter_time.selectStartTime" />
          <van-time-picker v-model="filter_time.selectEndTime" />
        </van-picker-group>
      </van-popup>

      <van-popup
        v-model:show="show_tip"
        round
        position="center"
        closeable
        :close-on-click-overlay="false"
        @close="handleSureClick"
      >
        <div class="popup-tip-box" v-if="tip_type == 1">
          <span
            >本周体育活动打卡已超过{{
              check_count
            }}次，本次打卡不再计入课外锻炼次数考勤要求。</span
          >
          <van-button @click="handleSureClick">确 认</van-button>
        </div>
        <!-- <div class="popup-tip-box" v-else-if="tip_type == 2">
          <span
            >本学期体育活动打卡已超过{{
              check_count
            }}次，本次打卡不再计入课外锻炼次数考勤要求。</span
          >
          <van-button @click="handleSureClick">确 认</van-button>
        </div> -->
        <div class="popup-tip-box" v-else-if="tip_type == 3">
          <span>不在打卡周期内，本次打卡不再计入课外锻炼次数考勤要求。</span>
          <van-button @click="handleSureClick">确 认</van-button>
        </div>
      </van-popup>

      <van-popup
        style="background-color: transparent"
        v-model:show="show_submit_loading"
        round
        position="center"
        :close-on-click-overlay="false"
      >
        <van-loading type="spinner" color="white" size="48" vertical
          >提交中，请勿关闭</van-loading
        >
      </van-popup>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import radio_select from "@/assets/radio_select.png";
import radio_normal from "@/assets/radio_normal.png";
import req from "@/js/req";
import { showNotify } from "vant";
import moment from "moment";
import User from "@/js/user";

const router = useRouter();
const type_select = ref(0);

const show_time_picker = ref(false);
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1;
const monthStr = month.toString().padStart(2, "0");
const day = date.getDate();
const dayStr = day.toString().padStart(2, "0");
const currentDate = [year.toString(), monthStr, dayStr];
const maxDate = ref(new Date());
const noticeInfo = ref({});
const show_tip = ref(false);
const show_submit_loading = ref(false);
const tip_type = ref(1);
const check_count = ref(0);
const select_item_ = ref({});
const filter_time = reactive({
  selectDate: currentDate,
  selectStartTime: ["00", "00"],
  selectEndTime: ["00", "00"],
});
const fileList = ref([]);
const form = reactive({
  start_time: "",
  end_time: "",
  place_type: 1,
  place: "",
  isopen: 1,
  form_time_fmt: "",
  images: [],
  classify_id: "",
  item_id: "",
  item_name: "",
});

const clock_in_items = ref([]);

onMounted(() => {
  const cid = router.currentRoute.value.query.cid;
  getItems(cid);
  getNotice(cid);
});

const itemClick = (index) => {
  type_select.value = index;
  select_item_.value = clock_in_items.value[index];
};

const getItems = async (cid) => {
  const p = {
    page: 1,
    limit: 1000,
    classify_id: cid,
  };
  let data = await req.get(req.path.get_clockin_types, p);
  clock_in_items.value = data.list;
  form.classify_id = cid;
};

const getNotice = async (cid) => {
  const p = {
    page: 1,
    limit: 1000,
    classify_id: cid,
  };
  let data = await req.get(req.path.get_notice, p);
  noticeInfo.value = data;
};
const onOversize = (file) => {
  showNotify({ message: "图片大小不能超过5M", type: "warning" });
};
const onConfirmTimeFilter = () => {
  const year = filter_time.selectDate.join("-");
  const start_time = filter_time.selectStartTime.join(":");
  const end_time = filter_time.selectEndTime.join(":");

  const start_time_x = moment(year + " " + start_time).format("X");
  const end_time_x = moment(year + " " + end_time).format("X");
  if (end_time_x - start_time_x > 0) {
    form.start_time = start_time_x;
    form.end_time = end_time_x;
    form.form_time_fmt = year + " " + start_time + "-" + end_time;
    show_time_picker.value = false;
  } else {
    showNotify({ type: "warning", message: "结束时间需大于开始时间" });
  }
};

const startSubmit = async () => {
  if (select_item_.value.type == 1 && form.item_name.length < 1) {
    showNotify({ type: "warning", message: "请填写运动项目" });
    return;
  }
  if (form.form_time_fmt.length < 1) {
    showNotify({ type: "warning", message: "请选择运动时间" });
    return;
  }
  if (form.place.length < 1) {
    showNotify({ type: "warning", message: "请填写运动地点" });
    return;
  }
  if (fileList.value.length == 0) {
    showNotify({ type: "warning", message: "请选择要上传的照片" });
    return;
  }
  show_submit_loading.value = true;
  let upload_res = await uploadImageFile();
  const p = {
    ...User.getUTP(),
    ...form,
    item_id: clock_in_items.value[type_select.value].item_id,
  };
  let data = await req.post(req.path.clock_in, p);

  let { period_id, term_id, week_count, week_num } = data;
  show_submit_loading.value = false;
  if (term_id > 0 && period_id == 0) {
    show_tip.value = true;
    tip_type.value = 3;
  } else if (week_count > week_num) {
    show_tip.value = true;
    tip_type.value = 1;
    check_count.value = data.week_num;
  } else {
    if (Object.keys(data).includes("record_id")) {
      handleSureClick();
    } else {
      console.log("打卡出错了：", data);
    }
  }
};
const handleSureClick = () => {
  show_tip.value = false;
  showNotify({ type: "success", message: "打卡成功" });
  router.push({ path: "/" });
};
const uploadImageFile = () => {
  return new Promise(async (reject) => {
    let all_uploads = [];
    fileList.value.forEach((fileItem) => {
      const formData = new FormData();
      formData.append("file", fileItem.file);
      const upload_promise = req.postFile(
        req.path.file_post,
        User.getUTP(),
        formData
      );
      all_uploads = [...all_uploads, upload_promise];
    });
    let all_uploads_over = await Promise.all(all_uploads);
    let images_ = [];
    all_uploads_over.forEach((item) => {
      images_.push(item.file_name);
    });
    form.images = JSON.stringify(images_);
    reject(true);
  });
};
</script>
<style lang="scss" scoped>
.app-container-box {
  padding: 16px;

  .check-in--box {
    .check-in-types {
      .check-button {
        width: 170px;
        height: 64px;
        margin-right: 12px;
        margin-top: 16px;

        &:nth-of-type(4n) {
          margin-right: 0;
        }

        // &:nth-of-type(4n){
        //   margin-top: 0px;
        // }
      }
    }
  }

  .check-in-form {
    .form-item {
      width: 100%;
      margin-top: 32px;

      .item-label {
        font-size: 32px;
        font-weight: bold;
        color: var(--c-text-color-black-8);

        .item-label-tip {
          font-weight: normal;
          font-size: 24px;
        }
      }

      .time-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;

        .time-box-line {
          width: 20px;
          height: 2px;
          display: inline-block;
          background-color: var(--c-text-color-black-8);
        }
      }
    }
  }

  .radio-img-icon {
    width: 40px;
    height: 40px;
  }
}

.tip-box {
  background: #faf3e3;
  border: 1px solid #dcb34c;
  margin-bottom: var(--van-tabbar-height);
  font-size: 28px;
  color: #b78200;
  margin-top: 64px;
  padding: 24px 40px;
  white-space: pre-wrap;

  .tip-head {
    display: flex;
    align-items: flex-start;
    line-height: 1.8;

    // font-weight: bold;
    img {
      width: 44px;
      margin-right: 24px;
    }
  }

  .tip-content {
    text-indent: 50px;
    margin: 16px 0px;
  }

  .tip-footer {
    padding-left: 65px;
    font-weight: bold;
  }
}

::v-deep .van-cell {
  padding: 0;
  background-color: transparent;
}

::v-deep .van-cell-group {
  background-color: transparent;
}

.loading-class {
  font-weight: bold;
  color: white;
}

.popup-tip-box {
  width: 640px;
  height: 408px;
  border: 8px solid var(--van-blue);
  font-size: 32px;
  color: var(--c-text-color-black-8);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0 70px;
  box-sizing: border-box;
  text-align: justify;

  .van-button {
    width: 240px;
    height: 80px;
    font-size: 32px;
    background: var(--c-blue-linear-gradient-1);
    color: white;
    margin-top: 45px;
  }
}

.input-field {
  background-color: white;
  padding: 16px;
  border: 1px solid rgba(131, 133, 136, 0.4);
  box-shadow: inset 4px 4px 10px 0px rgba(31, 29, 29, 0.08);
}

.start-time {
  width: 320px;
}

.upload-button {
  width: 220px;
  height: 165px;
  background-color: white;
  border-radius: 0;
  border: 1px dotted var(--c-text-color-gray-4);
  color: var(--c-text-color-gray-4);
  font-size: 36px;
  font-weight: bold;
}

.input-field-margin {
  margin-top: 16px;
}

.upload-form-item {
  display: flex;
  flex-direction: column;
}

.submit-button {
  margin-top: 64px;

  width: 100%;
  height: 96px;
  background: var(--c-blue-linear-gradient-1) !important;
  font-weight: bold;
  font-size: 38px;
}

::v-deep .van-uploader__preview {
  margin-right: 29px;

  &:last-of-type {
    margin-right: 0;
  }
}
</style>
